export default "__VITE_ASSET__DSx40_PX__"